// modules/WorldNPC/WorldNPCEvent.js
// NPC事件处理模块

import DebugHelper from '../DebugHelper.js';
import GameStateStore from '../GameStateStore.js';

export default class WorldNPCEvent {
    constructor(scene, npcManager) {
        this.scene = scene;
        this.npcManager = npcManager;
    }
    
    /**
     * 检查并触发跨场景事件
     */
    checkAndTriggerEvents() {
        const triggeredEvents = GameStateStore.getTriggeredEvents();
        if (!triggeredEvents) {
            return;
        }

        const currentSceneKey = this.scene.scene.key;
        const npcs = this.npcManager.npcs;
        
        // 遍历所有NPC，检查是否有匹配的事件
        npcs.forEach(npc => {
            const config = npc.config;
            
            // 检查NPC是否有事件配置
            if (!config.event || !config.event.trigger) {
                return;
            }
            
            const eventConfig = config.event;
            
            // 检查是否有匹配的触发事件
            for (let i = triggeredEvents.length - 1; i >= 0; i--) {
                const triggeredEvent = triggeredEvents[i];
                
                // 检查是否匹配：场景、触发名称、位置
                if (triggeredEvent.targetScene === currentSceneKey &&
                    triggeredEvent.triggerName === eventConfig.triggerName &&
                    triggeredEvent.triggerX === eventConfig.triggerX &&
                    triggeredEvent.triggerY === eventConfig.triggerY) {
                    
                    // 触发事件
                    this.triggerNPCEvent(npc, eventConfig.result);
                    
                    // 移除已处理的事件（避免重复触发）
                    triggeredEvents.splice(i, 1);
                    
                    DebugHelper.log(`WorldNPCEvent: 触发NPC事件 ${npc.data.name}`);
                    break; // 每个NPC只触发一次事件
                }
            }
        });
    }
    
    /**
     * 触发NPC事件，更新NPC的名字和对话
     * @param {Object} npc - NPC对象
     * @param {Object} result - 事件结果配置
     */
    triggerNPCEvent(npc, result) {
        if (!npc || !result) {
            DebugHelper.warn('WorldNPCEvent: 触发事件失败，参数无效');
            return;
        }
        
        // 更新NPC名字
        if (result.name) {
            npc.data.name = result.name;
            npc.config.name = result.name;
            DebugHelper.log(`WorldNPCEvent: 更新NPC名字为 ${result.name}`);
        }
        
        // 更新NPC对话
        if (result.dialog && Array.isArray(result.dialog)) {
            npc.data.dialog = result.dialog;
            npc.config.dialog = result.dialog;
            DebugHelper.log(`WorldNPCEvent: 更新NPC对话为 ${result.dialog.join(', ')}`);
        }
        
        // 更新NPC方向（如果有）
        if (result.direction && npc.sprite) {
            // 可以在这里添加方向更新逻辑
            DebugHelper.log(`WorldNPCEvent: 更新NPC方向为 ${result.direction}`);
        }
        
        // 标记事件已触发（避免重复触发）
        npc.data.eventTriggered = true;
        npc.config.eventTriggered = true;
    }
}

